import React, { Fragment } from 'react';
import Breadcrumbs from '../../CommonElements/Breadcrumbs';
import TasksContainSp from '../../Component/TasksAoSp/sptasks';

const TasksAOContainSp = () => {
  return (
    <Fragment>
      {/* <Breadcrumbs parent="Tasks" title="Manage Tasks" />
      <hr></hr> */}
      <TasksContainSp />
    </Fragment>
  );
};
export default TasksAOContainSp;